import { useRef } from "react"

export const useScrollRef = () => {
  const scrooledRef = useRef<HTMLDivElement>(null)
  return {
    scrooledRef,
    scrollToRef: () => {
      setTimeout(() => {
        scrooledRef.current?.scrollIntoView({
          block: "nearest",
        })
      }, 80)
    },
  }
}
